import { CUSTOM_SCHEME_ID_RE, DEFAULT_SCHEME_ID_RE } from '../constants/color-schemes';

const getColorTypeFromSchemeId = (schemeId) => {
  const customMatch = CUSTOM_SCHEME_ID_RE.exec(schemeId);
  if (customMatch) return customMatch[1];

  const defaultMatch = DEFAULT_SCHEME_ID_RE.exec(schemeId);
  return defaultMatch ? defaultMatch[1] : null;
};

export default getColorTypeFromSchemeId;
